import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const NylonBomberVest = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.jackets.NylonBomberVest.itemName}
      name={SS23.jackets.NylonBomberVest.itemName}
      price={SS23.jackets.NylonBomberVest.itemPrice}
      fabric={SS23.jackets.NylonBomberVest.itemFabric}
      src={SS23.jackets.NylonBomberVest.sizeChart}
      divId={SS23.jackets.NylonBomberVest.shopifyDivId}
      mainId={SS23.jackets.NylonBomberVest.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.jackets.NylonBomberVest.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.jackets.NylonBomberVest.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default NylonBomberVest;
